import Shimmer from '@components/core/Shimmer/Shimmer';
import ShimmerWrapper from '@components/core/Shimmer/ShimmerWrapper';

const RecruitmentFlowSkeleton = () => {
    return (<ShimmerWrapper spacing={16} direction='column' align='flex-start'>
        {Array.from({ length: 4 }).map((_, index) => (
            <ShimmerWrapper key={index} spacing={16} direction='row' align='flex-start' justify='space-between'>
                <Shimmer width="30%" height={32} radius={6} />
                <Shimmer width="20%" height={32} radius={6} />
                <Shimmer width="20%" height={32} radius={6} />
                <Shimmer width="30%" height={32} radius={6} />
            </ShimmerWrapper>
        ))}
    </ShimmerWrapper>);
};

export default RecruitmentFlowSkeleton;